import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Divider, Link, Stack, Typography, useTheme } from "@mui/material";

export const LegalDisclaimer = () => {
    const theme = useTheme();
    const currentYear = new Date().getFullYear();

    return (
        <Box sx={{ mt: 4 }}>
            <Divider sx={{ mb: 2, borderColor: theme.palette.grey[200] }} />
            <Stack
                direction="row"
                spacing={1.5}
                alignItems="flex-start"
                sx={{
                    px: 1,
                    py: 1.5,
                }}
            >
                <InfoOutlinedIcon
                    sx={{
                        fontSize: 16,
                        color: "text.disabled",
                        mt: 0.25,
                        flexShrink: 0,
                    }}
                />
                <Typography
                    variant="caption"
                    sx={{
                        color: "text.secondary",
                        lineHeight: 1.6,
                    }}
                >
                    © ContractScope, Inc. {currentYear}. Subject to{" "}
                    <Link
                        href="https://www.insurescope.ai/terms-of-service"
                        target="_blank"
                        rel="noopener"
                        sx={{
                            color: "text.secondary",
                            textDecorationColor: theme.palette.grey[400],
                            "&:hover": {
                                color: "primary.main",
                            },
                        }}
                    >
                        Terms of Service
                    </Link>{" "}
                    and{" "}
                    <Link
                        href="https://www.insurescope.ai/privacy-policy"
                        target="_blank"
                        rel="noopener"
                        sx={{
                            color: "text.secondary",
                            textDecorationColor: theme.palette.grey[400],
                            "&:hover": {
                                color: "primary.main",
                            },
                        }}
                    >
                        Privacy Policy
                    </Link>
                    . This content is for informational purposes only and does
                    not constitute legal advice.
                </Typography>
            </Stack>
        </Box>
    );
};
